import { z } from 'zod';

const INVALID_IMAGE_URL_MESSAGE =
  'Invalid image URL format. Must be a valid HTTP/HTTPS URL.';

export const uuidValidator = z.string().uuid('Invalid UUID format');

export const nonEmptyParamValidator = (paramName: string) =>
  z.string().min(1, `${paramName} cannot be empty`);

export const positiveNumberQueryValidator = (
  fieldName: string,
  defaultValue = 30,
) =>
  z
    .string()
    .optional()
    .refine((value) => {
      if (value === undefined) {
        return true;
      }
      const num = Number(value);
      return !isNaN(num) && num > 0;
    }, `${fieldName} must be a positive number`)
    .transform((value) => {
      return value === undefined ? defaultValue : value;
    });

export const imageUrlValidator = z
  .string()
  .url({ message: INVALID_IMAGE_URL_MESSAGE })
  .refine((val) => val.startsWith('http://') || val.startsWith('https://'), {
    message: INVALID_IMAGE_URL_MESSAGE,
  });

export const optionalImageUrlValidator = imageUrlValidator
  .optional()
  .nullable();
